(() => {
  if (window.linkedProductCardsInitialized) return;
  window.linkedProductCardsInitialized = true;
  const cache = new Map();
  const requests = new WeakMap();
  function remember(key, value) {
    cache.delete(key);
    cache.set(key, value);
    while (cache.size > 30) cache.delete(cache.keys().next().value);
  }
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[data-linked-url]');
    const options = link?.closest('[data-linked-context="card"]');
    const card = options?.closest('[data-linked-card]');
    if (!card) return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const previous = requests.get(card);
    previous?.abort();
    if (link.getAttribute('aria-current') === 'true') {
      card.removeAttribute('data-linked-loading');
      card.removeAttribute('aria-busy');
      return;
    }
    const controller = new AbortController();
    requests.set(card, controller);
    card.setAttribute('data-linked-loading', '');
    card.setAttribute('aria-busy', 'true');
    const target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    target.searchParams.set('section_id', 'linked-product-card');
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    const key = target.href;
    try {
      let html = cache.get(key);
      if (html) remember(key, html);
      else {
        const response = await fetch(key, { signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Card unavailable');
        html = await response.text();
      }
      if (controller.signal.aborted || !card.isConnected) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-linked-card-response] [data-linked-card]');
      if (!replacement) throw new Error('Missing card');
      remember(key, html);
      const focusedId = link.dataset.linkedId;
      const presentationClasses = [...card.classList].filter(name => !/^t4s-pr-\d+$/.test(name) && name !== 'is-t4s-pr-created' && name !== 't4s-pr-sold_out');
      replacement.className = presentationClasses.join(' ');
      const targetId = JSON.parse(replacement.getAttribute('data-product-options')).id;
      replacement.classList.add(`t4s-pr-${targetId}`);
      replacement.style.cssText = card.style.cssText;
      replacement.dataset.linkedShowVendor = card.dataset.linkedShowVendor;
      replacement.dataset.linkedCollectionInfo = card.dataset.linkedCollectionInfo;
      if (card.dataset.linkedCollectionInfo !== 'true') replacement.querySelectorAll('.jm-star-rating, .t4s-price__discount, .eta').forEach(el => el.remove());
      if (card.dataset.linkedShowVendor !== 'true') replacement.querySelector('.t4s-product-vendor')?.remove();
      const wrapper = replacement.querySelector('[hdt-reveal]');
      if (wrapper) { wrapper.style.opacity = '1'; wrapper.style.transform = 'none'; }
      card.replaceWith(replacement);
      window.T4SThemeSP?.reinitProductGridItem?.();
      window.T4SThemeSP?.ProductItem?.init?.();
      window.T4SThemeSP?.ProductItem?.resizeObserver?.();
      window.T4SThemeSP?.Countdown?.();
      const masonry = replacement.closest('.isotopet4s');
      if (masonry && window.jQuery_T4NT) window.jQuery_T4NT(masonry).isotopet4s('reloadItems').isotopet4s('layout');
      const focusLink = [...replacement.querySelectorAll('a[data-linked-id]')].find(item => item.dataset.linkedId === focusedId && item.dataset.linkedAxis === link.dataset.linkedAxis);
      focusLink?.focus({ preventScroll: true });
    } catch (error) {
      if (controller.signal.aborted || !card.isConnected) return;
      window.location.assign(link.href);
    } finally {
      if (requests.get(card) === controller) {
        card.removeAttribute('data-linked-loading');
        card.removeAttribute('aria-busy');
        requests.delete(card);
      }
    }
  }, true);
})();
